import { gql } from 'urql';

export const PROVEEDOR_FIELDS = gql`
  fragment ProveedorFields on Proveedor {
    id
    razon_social
    cuit
    condicion_iva
    contacto_nombre
    contacto_tel
    contacto_email
    direccion
    localidad_id
    provincia_id
    observaciones
    estado
  }
`;

export const Q_PROVEEDORES = gql`
  ${PROVEEDOR_FIELDS}
  query Proveedores($filter: ProveedorFilterInput) {
    proveedores(filter: $filter) {
      items {
        ...ProveedorFields
      }
      total
    }
  }
`;

export const Q_PROVEEDOR = gql`
  ${PROVEEDOR_FIELDS}
  query Proveedor($id: ID!) {
    proveedor(id: $id) {
      ...ProveedorFields
    }
  }
`;

export const M_CREATE_PROVEEDOR = gql`
  ${PROVEEDOR_FIELDS}
  mutation ProveedorCreate($input: ProveedorCreateInput!) {
    proveedorCreate(input: $input) {
      ...ProveedorFields
    }
  }
`;

export const M_UPDATE_PROVEEDOR = gql`
  ${PROVEEDOR_FIELDS}
  mutation ProveedorUpdate($id: ID!, $input: ProveedorUpdateInput!) {
    proveedorUpdate(id: $id, input: $input) {
      ...ProveedorFields
    }
  }
`;

export const M_TOGGLE_PROVEEDOR_ESTADO = gql`
  ${PROVEEDOR_FIELDS}
  mutation ProveedorToggleEstado($id: ID!) {
    proveedorToggleEstado(id: $id) {
      ...ProveedorFields
    }
  }
`;
